import React from 'react';
import { Plus } from 'lucide-react';

const QuickActionCard = ({ icon: Icon = Plus, title, description, onClick, color = "green" }) => {
  const hoverColors = {
    green: { borderColor: '#22c55e', backgroundColor: 'rgba(220, 252, 231, 0.5)' },
    blue: { borderColor: '#3b82f6', backgroundColor: 'rgba(219, 234, 254, 0.5)' },
    purple: { borderColor: '#a855f7', backgroundColor: 'rgba(243, 232, 255, 0.5)' },
    orange: { borderColor: '#f97316', backgroundColor: 'rgba(255, 237, 213, 0.5)' },
    indigo: { borderColor: '#6366f1', backgroundColor: 'rgba(224, 231, 255, 0.5)' },
    pink: { borderColor: '#ec4899', backgroundColor: 'rgba(252, 231, 243, 0.5)' },
    teal: { borderColor: '#14b8a6', backgroundColor: 'rgba(204, 251, 241, 0.5)' }
  };

  const iconColors = {
    green: '#16a34a',
    blue: '#2563eb',
    purple: '#9333ea',
    orange: '#ea580c',
    indigo: '#4f46e5',
    pink: '#db2777',
    teal: '#0d9488'
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px',
        border: '2px dashed',
        borderColor: isHovered ? hoverColors[color].borderColor : '#d1d5db',
        borderRadius: '8px',
        transition: 'all 0.2s',
        backgroundColor: isHovered ? hoverColors[color].backgroundColor : 'transparent',
        cursor: 'pointer',
        width: '100%'
      }}
    >
      <Icon style={{ color: iconColors[color] }} size={24} />
      <div style={{ textAlign: 'left' }}>
        <p style={{ fontWeight: '600', color: '#111827', margin: 0 }}>{title}</p>
        {description && <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>{description}</p>}
      </div>
    </button>
  );
};

export default QuickActionCard;